<template>
	<svg :class="classes" aria-hidden="true" role="img" width="24" height="24">
		<use :xlink:href="href" />
	</svg>
</template>

<script setup>
/* globals sh_icons */

const props = defineProps({
	slug: {
		type: String,
		required: true,
	},
});

const classes = [`icon`, `icon-${props.slug}`];

const href = `${sh_icons.src}#icon-${props.slug}`;
</script>
